var render = function render(){var _vm=this,_c=_vm._self._c;return _c('box',{staticClass:"rules"},[(_vm.rules)?_c('wysiwyg-viewer',{staticClass:"rules-wrapper",domProps:{"innerHTML":_vm._s(_vm.rules.replaceAll(';amp', '').replace('&', '&'))}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }